/* Search: the header field's suggestion panel and the results page.
   Suggestions come from the ca-search-suggest section through
   /search/suggest (Section Rendering API); the results page loads its
   remaining pages the same way, then filters, sorts and caps in the
   browser. Add to cart buttons are handled by ca-species.js. */
(function () {
  'use strict';
  if (window.__caSearch) return;
  window.__caSearch = true;

  function track(name, data) {
    try { if (window.clarity) window.clarity('event', name); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, data || {});
      }
    } catch (e) {}
  }

  function sectionHtml(text, id) {
    var doc = new DOMParser().parseFromString(text, 'text/html');
    return doc.getElementById('shopify-section-' + id) || doc.body;
  }

  // ---------- The field and its panel ----------
  document.querySelectorAll('[data-ca-search]').forEach(function (root) {
    var input = root.querySelector('[data-ca-search-input]');
    var panel = root.querySelector('[data-ca-search-panel]');
    var empty = root.querySelector('[data-ca-search-empty]');
    var results = root.querySelector('[data-ca-search-results]');
    var url = root.getAttribute('data-ca-search-url') || '/search/suggest';
    if (!input || !panel || !empty || !results) return;
    var cache = {};
    var timer = null;
    var controller = null;
    var latest = '';

    function open() { panel.hidden = false; }
    function close() { panel.hidden = true; }
    function showEmpty() { empty.hidden = false; results.hidden = true; }
    function showResults(html) { results.innerHTML = html; results.classList.remove('is-loading'); results.hidden = false; empty.hidden = true; }

    function suggest() {
      var q = input.value.trim();
      latest = q;
      if (controller) controller.abort();
      if (q.length < 2) { showEmpty(); return; }
      if (cache[q]) { showResults(cache[q]); return; }
      results.classList.add('is-loading');
      controller = window.AbortController ? new AbortController() : null;
      var params = 'q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=product,collection,page,article' +
        '&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
        '&section_id=ca-search-suggest';
      fetch(url + '?' + params, controller ? { signal: controller.signal } : {}).then(function (r) {
        if (!r.ok) throw new Error('suggest');
        return r.text();
      }).then(function (text) {
        var html = sectionHtml(text, 'ca-search-suggest').innerHTML;
        cache[q] = html;
        if (latest === q) showResults(html);
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        results.classList.remove('is-loading');
      });
    }

    input.addEventListener('focus', function () { open(); suggest(); });
    input.addEventListener('input', function () {
      open();
      clearTimeout(timer);
      timer = setTimeout(suggest, 200);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.blur(); }
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });
    root.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !root.contains(e.relatedTarget)) close();
    });
    root.querySelector('form').addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); return; }
      track('ca_search_submit', { q: input.value.trim() });
    });
  });

  // ---------- The results page ----------
  document.querySelectorAll('[data-ca-results]').forEach(function (root) {
    var id = root.getAttribute('data-ca-results-section');
    var mode = root.getAttribute('data-ca-results-mode');
    var grid = root.querySelector('[data-ca-results-grid]');
    var tools = root.querySelector('[data-ca-results-tools]');
    var more = root.querySelector('[data-ca-results-more]');
    var pages = root.querySelector('[data-ca-results-pages]');
    var sort = root.querySelector('[data-ca-results-sort]');
    var capPhone = parseInt(root.getAttribute('data-ca-results-cap') || '8', 10);
    var capDesktop = parseInt(root.getAttribute('data-ca-results-cap-desktop') || '24', 10);

    // The other tab's count, read from the same section rendered for that type.
    var other = root.getAttribute('data-ca-results-other');
    if (other && id && mode !== 'mixed') {
      fetch(other + '&section_id=' + encodeURIComponent(id)).then(function (r) { return r.ok ? r.text() : ''; }).then(function (text) {
        if (!text) return;
        var key = mode === 'product' ? 'content' : 'product';
        var from = sectionHtml(text, id).querySelector('[data-ca-results-count-for="' + key + '"]');
        var to = root.querySelector('[data-ca-results-count-for="' + key + '"]');
        if (from && to && from.textContent) to.textContent = from.textContent;
      }).catch(function () {});
    }

    if (!grid || mode !== 'product') return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-ca-results-card]'));
    cards.forEach(function (c, i) { c.setAttribute('data-ca-index', i); });
    var state = { species: 'all', type: '', sort: 'match', showAll: false };

    function has(card, attr, value) {
      return (' ' + (card.getAttribute(attr) || '') + ' ').indexOf(' ' + value + ' ') >= 0;
    }
    function phone() { return window.matchMedia('(max-width: 768px)').matches; }

    function show() {
      var order = cards.slice();
      if (state.sort === 'price-asc') order.sort(function (a, b) { return Number(a.getAttribute('data-ca-price')) - Number(b.getAttribute('data-ca-price')); });
      else if (state.sort === 'price-desc') order.sort(function (a, b) { return Number(b.getAttribute('data-ca-price')) - Number(a.getAttribute('data-ca-price')); });
      else if (state.sort === 'new') order.sort(function (a, b) { return Number(b.getAttribute('data-ca-date')) - Number(a.getAttribute('data-ca-date')); });
      else order.sort(function (a, b) { return Number(a.getAttribute('data-ca-index')) - Number(b.getAttribute('data-ca-index')); });
      order.forEach(function (c) { grid.appendChild(c); });
      var cap = state.showAll ? order.length : (phone() ? capPhone : capDesktop);
      var matched = 0;
      order.forEach(function (c) {
        var ok = (state.species === 'all' || has(c, 'data-ca-species', state.species)) && (!state.type || has(c, 'data-ca-types', state.type));
        if (ok) matched += 1;
        c.hidden = !ok || matched > cap;
      });
      if (more) {
        more.hidden = matched <= cap;
        more.textContent = 'Show all ' + matched;
      }
    }

    function chips() {
      root.querySelectorAll('[data-ca-results-group]').forEach(function (group) {
        var attr = group.getAttribute('data-ca-results-group') === 'species' ? 'data-ca-species' : 'data-ca-types';
        var any = false;
        group.querySelectorAll('[data-ca-results-chip]').forEach(function (chip) {
          var value = chip.getAttribute('data-ca-results-chip');
          if (value === 'all') return;
          var found = cards.some(function (c) { return has(c, attr, value); });
          chip.hidden = !found;
          if (found) any = true;
        });
        group.hidden = !any;
      });
    }

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-ca-results-chip]');
      if (!chip) return;
      var group = chip.closest('[data-ca-results-group]');
      var kind = group.getAttribute('data-ca-results-group');
      var value = chip.getAttribute('data-ca-results-chip');
      if (kind === 'species') {
        state.species = value;
      } else {
        // A type chip toggles: tapping the pressed one clears it.
        state.type = state.type === value ? '' : value;
        value = state.type;
      }
      group.querySelectorAll('[data-ca-results-chip]').forEach(function (c) {
        c.setAttribute('aria-pressed', c.getAttribute('data-ca-results-chip') === value ? 'true' : 'false');
      });
      state.showAll = false;
      show();
      track('ca_search_filter', { kind: kind, value: value });
    });
    if (sort) sort.addEventListener('change', function () { state.sort = sort.value; show(); });
    if (more) more.addEventListener('click', function () { state.showAll = true; show(); });
    window.addEventListener('resize', show);

    if (tools) tools.hidden = false;
    chips();
    show();

    // Load the remaining pages (up to 6 in all) so the chips, the sort and
    // Show all cover every result, then drop the page links.
    var current = pages ? parseInt(pages.getAttribute('data-ca-results-page') || '1', 10) : 1;
    var totalAll = pages ? parseInt(pages.getAttribute('data-ca-results-total') || '1', 10) : 1;
    var total = Math.min(totalAll, 6);
    if (!pages || current !== 1 || total < 2 || !id) return;
    var base = window.location.pathname + window.location.search.replace(/([?&])page=\d+&?/, '$1');
    base += (base.indexOf('?') >= 0 ? '&' : '?');
    var jobs = [];
    for (var p = 2; p <= total; p += 1) {
      jobs.push(fetch(base + 'page=' + p + '&section_id=' + encodeURIComponent(id)).then(function (r) {
        if (!r.ok) throw new Error('page');
        return r.text();
      }));
    }
    Promise.all(jobs).then(function (texts) {
      texts.forEach(function (text) {
        sectionHtml(text, id).querySelectorAll('[data-ca-results-card]').forEach(function (card) {
          card.setAttribute('data-ca-index', cards.length);
          cards.push(card);
          grid.appendChild(card);
        });
      });
      if (totalAll <= 6) pages.hidden = true;
      chips();
      show();
    }).catch(function () {});
  });
})();
